export const CANONICAL_SLIDE_TITLES: Record<number, string> = {
    1: 'Title Slide',
    2: 'Workshop Goals',
    3: 'Concept Introduction',
    4: 'Examples',
    5: 'Core Concept Deep Dive',
    6: 'How To Build / Apply the Concept',
    7: 'Practice Time',
    8: 'Media Anchor',
    9: 'Reflection & Group Sharing',
    10: 'Close & Homework',
};

export interface SessionDurationRow {
    session_number: number;
    completion_count: number;
    avg_seconds: number;
    median_seconds: number;
    min_seconds: number;
    max_seconds: number;
}

export interface SlideDurationRow {
    session_number: number;
    slide_number: number;
    slide_type: string;
    completion_count: number;
    avg_seconds: number;
    min_seconds: number;
    max_seconds: number;
}

export interface SlideTypeDurationRow {
    slide_type: string;
    completion_count: number;
    avg_seconds: number;
    median_seconds: number;
    min_seconds: number;
    max_seconds: number;
}

export interface AthleteSlide {
    slide_number: number;
    slide_type: string;
    duration_seconds: number;
}

export interface AthleteSession {
    session_number: number;
    session_duration_seconds: number | null;
    slides: AthleteSlide[];
}

export interface AthleteTimeline {
    athlete_id: number;
    athlete_name: string;
    sessions: AthleteSession[];
}

export interface SlidesSeenRow {
    slide_number: number;
    /** Distinct learners (assignments) who viewed this slide */
    unique_assignment_count: number;
    /** Total slide views */
    count: number;
}

export interface ReportSection<T> {
    rows: T[];
    key_takeaway: string;
}

export interface EngagementReportData {
    header: {
        organization_name: string;
        report_date: string;
        plan_count: number;
        athlete_count: number;
    };
    session_durations: ReportSection<SessionDurationRow>;
    slide_durations: ReportSection<SlideDurationRow>;
    slide_type_durations: ReportSection<SlideTypeDurationRow>;
    athlete_timeline: {
        athletes: AthleteTimeline[];
    };
    slides_seen: {
        rows: SlidesSeenRow[];
    };
    recommendations: string[];
}

export function formatDuration(seconds: number | null | undefined): string {
    if (seconds == null) return '--';
    const s = Math.round(seconds);
    if (s < 60) return `${s}s`;
    const m = Math.floor(s / 60);
    const rem = s % 60;
    if (rem === 0) return `${m}m`;
    return `${m}m ${rem}s`;
}
